export const CANCEL_BOOKING = 'cancel-booking';
const cancelBooking = ({ booking }) => ({
  type: CANCEL_BOOKING,
  payload: { booking },
});

export default cancelBooking;
